module.exports = __webpack_public_path__ + "static/media/yin-yang.d2225940.svg";